module.exports = __webpack_public_path__ + "media/foot_locker_scholar_athletes_program_2018/headline-a628f646.png";